export default "__VITE_ASSET__DeeOqalL__"